<template>
  <b-modal id="bv-modal-textarea"
           @hide="onHide"
           @ok="onOk"
           ref="modal"
           :ok-disabled="result===''"
           ok-variant="plm-primary"
           cancel-variant="plm-secondary"
  >
    <template v-slot:modal-title>
      {{title}}
    </template>
    <div class="d-block text-center">
      <b-form-group :label="message" >
        <textarea class="form-control" rows="4" cols="50" v-model="result" :maxlength="maxLength"></textarea>
      </b-form-group>
    </div>


    <template v-if="deleteOption" #modal-footer="{close}">
      <b-container class="pl-0">
        <b-row >
          <b-col class="text-right">
            <b-button
                variant="plm-secondary"
                @click="onHide"
            >Cancel</b-button>
            <b-button
                :disabled="result===''"
                variant="plm-danger"
                @click="onOk"
            >Delete
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </template>

  </b-modal>

</template>

<script>
export default {
  name: "TextareaDialog",
  async beforeMount() {
  },
  methods: {
    async onOk(ev){
      if(this.resolve != null){
        this.resolve(this.result);
        this.resolve = null;
      }
      this.$refs.modal.hide();
    },
    async onHide(ev){
      if(this.resolve != null){
        this.resolve(null);
        this.resolve = null;
      }
      this.$refs.modal.hide();
    },
    reset(){
      this.result = "";
      this.resolve = null;
    }
  },
  data: () => ({
    deleteOption: false,
    title:"title",
    message:"message",
    resolve: null,
    result:'',
    maxLength: 1000
  })
}
</script>
